import { render, staticRenderFns } from "./ContactSideNav.vue?vue&type=template&id=9f8cfc22&scoped=true&"
import script from "./ContactSideNav.vue?vue&type=script&lang=js&"
export * from "./ContactSideNav.vue?vue&type=script&lang=js&"
import style0 from "./ContactSideNav.vue?vue&type=style&index=0&id=9f8cfc22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8cfc22",
  null
  
)

export default component.exports